import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  menuCPUPlanReport: [],
  loading: false,
  error: null,
};

export const fetchInitiateCPUMenuPlanReport = createAsyncThunk(
  'initialMenuCPUPlanReport/fetchInitiateMenuCPUPlanReport',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetCPUPlannedMenu`, payload);
    return response?.data;
  }
);

const initiateMenuPlanCPUPlannedReportSlice = createSlice({
  name: 'initialMenuCPUPlanReport',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInitiateCPUMenuPlanReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitiateCPUMenuPlanReport.fulfilled, (state, action) => {
        state.loading = false;
        state.menuCPUPlanReport = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchInitiateCPUMenuPlanReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default initiateMenuPlanCPUPlannedReportSlice.reducer;
